import { RouteName } from '@/base/constants/route'

const callbackRotes = {
  path: '/callback',
  name: RouteName.CALLBACK,
  meta: {
    title: 'Callback',
    analyticsPageName: 'Integration Callback',
  },
  component: () => import('@/layouts/Blank.vue'),
  children: [
    {
      path: 'play-store-integration',
      name: RouteName.CALLBACK_PLAY_STORE_INTEGRATION,
      meta: {
        title: 'Google Play Store Integration',
        analyticsPageName: 'Integration Callback - Google Play Store',
      },
      component: () => import('@/pages/callback/play-store-integration/index.vue'),
    },
  ],
}

export default callbackRotes
